export default {"src":"/_next/static/media/worrying-man.dc62d2f5.svg","height":291,"width":330};